/** Map Docker-only local Storage links to the frontend's configured gateway.
 * Preserve the signed path/query; never derive the target from a request header.
 * Hosted Storage links are left unchanged.
 */
export function inboxStorageUrl(
  signedUrl: string,
  publicSupabaseUrl: string
): string {
  const signed = new URL(signedUrl);
  if (signed.hostname !== 'kong') return signedUrl;
  const gateway = new URL(publicSupabaseUrl);
  if (
    signed.origin !== 'http://kong:8000' ||
    !['127.0.0.1', 'localhost', '[::1]'].includes(gateway.hostname) ||
    !['http:', 'https:'].includes(gateway.protocol) ||
    signed.username ||
    signed.password ||
    gateway.username ||
    gateway.password ||
    !signed.pathname.startsWith('/storage/v1/object/sign/')
  )
    throw new Error('INBOX_FILE_UNAVAILABLE');
  return `${gateway.origin}${signed.pathname}${signed.search}${signed.hash}`;
}
